export class DisconnectRestoreAwsOrganizationalUnitResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizationalUnit",
            "baseName": "organizationalUnit",
            "type": "RestoreAwsOrganizationalUnit",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DisconnectRestoreAwsOrganizationalUnitResponse.attributeTypeMap;
    }
    constructor() {
    }
}
